import { render, staticRenderFns } from "./PayOk.vue?vue&type=template&id=377ea9a7&"
import script from "./PayOk.vue?vue&type=script&lang=js&"
export * from "./PayOk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports